import React from "react";
import styled from "styled-components";
import { ContainerWrapper, SectionWrapper, ListUnstyled } from "../../Components/Utils";
import { AffiliatesLogos } from "../../Components/Partners/LogoImports";
import "../../Components/Partners/index.css";

const LogoItem = styled.li`
  padding: 0 .3rem;
  text-align: center;
  margin: 10px;
  width: 200px;
  height: auto;
  overflow: hidden;
`;

const LogoItemImage = styled.div`
  height: auto;
  width: 100%;
  overflow: hidden;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 10px 15px;

  a {
    border: 0;
    background: none;

    img {
      width: auto;
      height: auto;
      max-height: 100px;
      max-width: 100%;
      vertical-align: bottom;
    }
  }
`;

function EcosystemLogos () {
  return (
    <SectionWrapper backgroundColor="white" mb="3rem" className="w-100">
      <ContainerWrapper textAlign="center">
      <div className="text-left">
        <h3>Global ecosystem</h3>
        <p>Join an ecosystem that includes ventures, universities, regional innovation centres, professional associations, investment firms, service providers, international trade centers, government agencies, open source projects, municipalities and their own local networks.</p>
      </div>
        <ListUnstyled className="gers__logos d-flex flex--center">
          {
            AffiliatesLogos && AffiliatesLogos.sort((a, b) => {
              let a_ = a.name.toUpperCase();
              let b_ = b.name.toUpperCase();
              if (a_ < b_) { return -1; }
              if (a_ > b_) { return 1; }
              return 0;
            }).map((logo, index) => (
              <LogoItem key={logo.name.replace(/\s/g,'')} data-index={index}>
                <LogoItemImage>
                  <a href={logo.url ? logo.url :  "#"} target={logo.url ? "_blank" : "_self"} rel={logo.url && "noopener noreferrer"}>
                    <img src={logo.logo} alt={logo.name} title={logo.name} />
                  </a>
                </LogoItemImage>
              </LogoItem>
            ))
          }
        </ListUnstyled>
      </ContainerWrapper>
    </SectionWrapper>
  );
}


export default EcosystemLogos



// WEBPACK FOOTER //
// ./src/Pages/GERSModel/Ecosystem.js